import { ThemeColors } from '~/themes/colors'

interface ActiveCallBlockColors {
  CallBlockHeader: {
    NewCallButton: {
      Icon: {
        Default: ThemeColors
        Hover: ThemeColors
      }
      Background: {
        Default: ThemeColors
        Hover: ThemeColors
        Active: ThemeColors
      }
    }
    Border: ThemeColors
  }
  CallBlock: {
    StatusBadge: {
      Background: {
        Inactive: ThemeColors
        Active: {
          Keyframe_From: ThemeColors
          Keyframe_To: ThemeColors
        }
      }
      FontColor: {
        Active: ThemeColors
      }
    }
    ControlButtons: {
      EndCall: {
        Icon: ThemeColors
        Background: {
          Default: ThemeColors
          Hover: ThemeColors
          Opacity_Hover: ThemeColors
          Opacity_Active: ThemeColors
        }
      }
      Icon: {
        Default: ThemeColors
        Hover: ThemeColors
      }
      Background: {
        Default: ThemeColors
        Hover: ThemeColors
      }
    }
  }
}

export const activeCallBlockColors: ActiveCallBlockColors = {
  CallBlockHeader: {
    NewCallButton: {
      Icon: {
        Default: {
          default: 'gray.900',
        },
        Hover: {
          default: 'blue.900',
        },
      },
      Background: {
        Default: {
          default: 'achromatic.transparent',
        },
        Hover: {
          default: 'blue.300',
        },
        Active: {
          default: 'blue.900',
        },
      },
    },
    Border: {
      default: 'gray.500',
    },
  },
  CallBlock: {
    StatusBadge: {
      Background: {
        Inactive: {
          default: 'gray.400',
        },
        Active: {
          Keyframe_From: {
            default: 'green.800',
          },
          Keyframe_To: {
            default: 'green.600',
          },
        },
      },
      FontColor: {
        Active: {
          default: 'white',
        },
      },
    },
    ControlButtons: {
      EndCall: {
        Icon: {
          default: 'red.800',
        },
        Background: {
          Default: {
            default: 'achromatic.transparent',
          },
          Hover: {
            default: 'red.200',
          },
          Opacity_Hover: {
            default: 'opacity.60',
          },
          Opacity_Active: {
            default: 'opacity.100',
          },
        },
      },
      Icon: {
        Default: {
          default: 'gray.900',
        },
        Hover: {
          default: 'blue.900',
        },
      },
      Background: {
        Default: {
          default: 'achromatic.transparent',
        },
        Hover: {
          default: 'blue.300',
        },
      },
    },
  },
}
